var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { cn } from '../../lib/utils.js';
import { Badge } from './badge';
var outlineVariantMap = {
    default: 'default-outline',
    destructive: 'destructive-outline',
    success: 'success-outline',
    info: 'info-outline',
    warning: 'warning-outline',
    persimmon: 'persimmon-outline',
    danger: 'danger-outline',
    muted: 'muted-outline',
    'info-alt': 'info-alt-outline',
    'info-alt2': 'info-alt2-outline',
};
export function StatusBadge(_a) {
    var className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, _c = _a.includeDot, includeDot = _c === void 0 ? true : _c, _d = _a.pulseDot, pulseDot = _d === void 0 ? false : _d, children = _a.children, props = __rest(_a, ["className", "variant", "includeDot", "pulseDot", "children"]);
    return (<Badge className={cn('border-current/30', className)} variant={outlineVariantMap[variant]} {...props}>
      {includeDot && (<span className={cn('size-1.5 rounded-full bg-current/80', pulseDot && 'animate-pulse motion-reduce:animate-none')}/>)}
      {children}
    </Badge>);
}
